import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, ObjContext, MakeContext } from "./context";

export class Machine extends UnitType {
    readonly id = "machine";
    readonly displayName = "Machine";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.netherworld; }
    playerCanControl() { return false; }
    canEnter(ctx: PlaceContext) { return ctx.game.overworld.get(ctx.x, ctx.y)?.unitId !== "pentagram" && ctx.world.hasNearbyTile(ctx.x, ctx.y, "ocean") && this.inTile(ctx, ["land"], ctx.game.netherworld); }
    description() { return "Spends blood to make runes.\nRequires nearby lava."; }
    maxCooldown() { return 10000; }
    cost() { return { souls: 0, blood: 300, runes: 0 }; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "machine"); }
    aiAlwaysSteps(): boolean { return true; }
    step(ctx: ObjContext) {
        const { obj, faction } = ctx;
        if (!obj || !obj.isReady(this.maxCooldown())) return;
        obj.setNotReady();
        if (ctx.game.canPayCost(faction, 10, 0, 0)) {
            ctx.game.factionData[faction].blood -= 10;
            ctx.game.addResource(faction, "runes", 1);
        }
    }
}
